<template>
  <div class="box-wapr">
    <!-- 日期 -->
    <div class="box_new">
      <div class="box_input">
        <el-input v-model="input" placeholder="请选择日期" @focus="chang_Hand" style="width:25%"  suffix-icon="el-icon-date"></el-input>
          <el-select v-model="value" placeholder="选择类型" style="width:25%;margin:0 10px" @change="Selct_Table">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
       <div class="felx">
           <el-button type="info" size="mini" @click="listPaht">返回</el-button>
       </div>
      </div>
      <div class="title_end" v-if="listData == ''||dataFaly==''">
        <h1>该日期没有拍照信息</h1>
      </div>
      <!-- 图片 -->
      <div class="newImgs" :style="{height:Hendth+'px'}">
        <div class="imgs_box" v-for="(item,index) in listData" :key="index">
          <img
            :src="item.photo"
            alt
          />
          <p>{{item.addtime}}</p>
        </div>
        
      </div>
      <div class="flex_Fe" >
        <page-helper :page-data="pageData" :total="total" :get-table-list="zhua_Post"></page-helper>
      </div>
    </div>
    <!-- 日历弹出框 -->
    <el-dialog title="日历" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :modal="false"> 
        <div class="calender">
      <div class="top">
        <div class="top_date">{{year}}年{{month}}月</div>
        <div class="btn_wrap">
          <ul>
            <li @click="handleShowNextMonth">下个月</li>
            <li @click="handleShowToday">今天</li>
            <li @click="handleShowLastMonth">上个月</li>
          </ul>
        </div>
      </div>
      <div class="date_wrap">
        <ul class="week">
          <li>日</li>
          <li>一</li>
          <li>二</li>
          <li>三</li>
          <li>四</li>
          <li>五</li>
          <li>六</li>
        </ul>
        <!--  :class="{now:nowLi==year.toString()+month.toString()+item.day}" -->
        <ul class="day">
          <li
            v-for="(item,index) in days"
            :key="index"
            :class="{now:nowLi==year.toString()+month.toString()+item.day}"
            @click="HandClick(item)"
          >
            <span>{{item.day}}</span>
            <p :style="{background:item.times?'red':''}" class="fend" v-if="item.times"></p>
          </li>
        </ul>
      </div>
    </div>
    </el-dialog>
  </div>
  <!-- </div> -->
</template>

<script>
import { newDataLine,zhua_paiData } from "@/network/index";
import PageHelper from "@/components/common/PageHelper";
export default {
  components: {
    PageHelper
  },
  name: "calender",
  data() {
    return {
      dataFaly:[],
      dialogVisible:false,
      total: null,
      input: "",
      price: "",
      remaindNum: "",
      theDate: "",
      year: "",
      month: "",
      days: [],
      listData:[],//抓拍图片数组
      nowLi: "",
      arrty: [],
      queyData: [],
      monthinfo: "", //后台的日期
      options: [
        {
          value:'0',
          label:'定时抓拍'
        },
        // {
        //   value: "1",
        //   label: "报警抓拍"
        // },
        {
          value: "2",
          label: "手动抓拍"
        }
      ],
      value: "2",//抓拍
        pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30 //数据   pagesize几条数据
      },
    };
  },
  computed: {
    Hendth() {
      // console.log(document.body.clientHeight - 150)
      return document.body.clientHeight - 180;
    }
  },
  methods: {
    // 返回
    listPaht(){
      this.$router.push({
        path:'/list',
        query:{
          fly:true
        }
      })
    },
    // 下拉框谢欢状态
    Selct_Table(){
      this.days.forEach((item)=>{
        if(item.times){
          item.times = ''
        }
        
        // console.log(item)
      })
      this.dayMOUNend()//更换日历状态
      this.zhua_Post()//获取抓拍图片
    },
    // 获取抓拍图片
   async zhua_Post(){
      this.pageData.dateinfo = this.input
      this.pageData.flag = this.value
      this.pageData.monitor_uuid ='8E4570D3E15A980B0CC3E5096CEDA5A1'
      const {code,data} = await zhua_paiData(this.pageData)
      // console.log(data)
      if(code) {
        this.listData = data.list
        this.dataFaly = data
        this.total = Number(data.pagelist[0].allrow)
      } 
    },
    // 点击开启日期
    chang_Hand(){
      this.dialogVisible = true
    },
    // 关闭弹框
    handleClose(){
       this.dialogVisible = false
    },
    // 获取记录数据
    async dayMOUNend() {
      // console.log(this.$route)
      let {monitor_uuid} = this.$route.query
      // console.log(monitor_uuid)
      //  this.days = []
      let newMont = this.month > 10 ? this.month : "0" + this.month;
       let flag = this.value
      this.monthinfo = this.year + "-" + newMont;
      const { code, data } = await newDataLine(monitor_uuid,this.monthinfo,flag);
      this.days.forEach((item, index) => {
        if (item.day) {
          //  console.log(data[index].addtime)
          data.forEach(itemIN => {
            let daysl = itemIN.addtime.substring(8,9);
             let flyData = daysl == 0 ? itemIN.addtime.substring(9):itemIN.addtime.substring(8)//判断 如果是0的话就截取9位数如果不是就截取8位数
            if (flyData == item.day) {
              this.$set(item, "times", itemIN.addtime);
            }
            //
          });
        }
      });
      // console.log(this.days)
      // this.queyData = data
    },
    //获取点击的事件
    HandClick(item) {
      let now = new Date();
      // 点击日期切换颜色
      this.nowLi =
        this.year.toString() + this.month.toString() + item.day.toString();
      let newDataLint;
      // 判断 如果 是小于10话就有 0
      let dayL =
        item.day.toString() < 10
          ? 0 + item.day.toString()
          : item.day.toString();
      // console.log(now.getMonth() + 1)
      if (this.month.toString().toString() < 10) {
        newDataLint =
          this.year.toString() + "-" + "0" + this.month.toString() + "-" + dayL;
        // console.log(newDataLint)
      } else {
        newDataLint =
          this.year.toString() + "-" + this.month.toString() + "-" + dayL;
      }
      // 获取点击的日期
       this.input = newDataLint
        this.dialogVisible = false
      this.zhua_Post()
    },
    //控制当前日期显示特殊样式
    handleShowDateStyle() {
      let now = new Date();
      this.nowLi =
        now.getFullYear().toString() +
        (now.getMonth() + 1).toString() +
        now.getDate().toString();
      let monther =   (now.getMonth() + 1).toString()<10?'0'+  (now.getMonth() + 1).toString():  (now.getMonth() + 1).toString()
      let newDay =   now.getDate().toString()<10?'0'+  now.getDate().toString(): now.getDate().toString();

      this.input = now.getFullYear().toString()+"-"+monther+"-"+newDay//获取当前年月日
    },
    //得到当前年这个月分有多少天
    getDays(Y, M) {
      let day = new Date(Y, M, 0).getDate();
      return day;
    },
    //得到当前年，这个月的一号是周几
    getWeek(Y, M) {
      let now = new Date();
      now.setFullYear(this.year);
      now.setMonth(this.month - 1);
      now.setDate(1);
      let week = now.getDay();
      return week;
    },
    pushDays() {
      //将这个月多少天加入数组days
      for (let i = 1; i <= this.getDays(this.year, this.month); i++) {
        const list = {
          day: i
        };
        this.days.push(list); //这里是那道的天数
      }
      //将下个月要显示的天数加入days
      // for(let i = 1;i<=42-this.getDays(this.year,this.month)-this.getWeek(this.year,this.month);i++){
      //   this.days.push(i)
      // }
      //将上个月要显示的天数加入days
      for (let i = 0; i < this.getWeek(this.year, this.month); i++) {
        var lastMonthDays = this.getDays(this.year, this.month - 1);
        this.days.unshift(lastMonthDays - i);
      }
      // console.log("day", this.days);
      // console.log(this.getWeek(this.year, this.month));
    },
    getDate() {
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth() + 1;
      this.pushDays();
    },
    changeDate() {},
    handleShowNextMonth() {
      this.days = [];
      if (this.month < 12) {
        this.month = this.month + 1;
        this.pushDays();
      } else {
        this.month = this.month = 1;
        this.year = this.year + 1;
        console.log(11);
        this.pushDays();
      }

      /**获取下个月的日期 */
      let newMont = this.month > 10 ? this.month : "0" + this.month;
      this.monthinfo = this.year + "-" + newMont;
      this.dayMOUNend();
    },
    handleShowToday() {
      this.days = [];
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth() + 1;
      this.pushDays();
      let newMont = this.month > 10 ? this.month : "0" + this.month;
      this.monthinfo = this.year + "-" + newMont;
      this.dayMOUNend();
    },
    handleShowLastMonth() {
      this.days = [];
      if (this.month > 1) {
        this.month = this.month - 1;
        this.pushDays();
      } else if (this.year > 1970) {
        this.month = 12;
        this.year = this.year - 1;
        this.pushDays();
      } else {
        alert("不能查找更远的日期");
      }
      /**获取上个月的日期 */
      let newMont = this.month > 10 ? this.month : "0" + this.month;
      this.monthinfo = this.year + "-" + newMont;
      this.dayMOUNend();
    }
  },
  mounted() {
    this.getDate();
    this.handleShowDateStyle();
    this.dayMOUNend();
    this.zhua_Post()
  }
};
</script>
<style scoped>
.box_input {
  padding: 10px;
  display: flex;
}
.imgs_box {
  width: 16.6%;
  /* height: 100%; */
  padding: 0 5px;
}
.imgs_box p {
  height: 20px;
  text-align: center;
}
.flex_Fe {
  padding: 10px 0;
}
.newImgs {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
}
.box_new {
  width: 100%;
  height: 100%;
}
.imgs_box img {
  width: 100%;
  height: 160px;
}
.box-wapr {
  width: 100%;
  display: flex;
}
.calender {
  width: 100%;
  position: relative;
  /* display: flex; */
  /* margin-top: 50px; */
  border: 1px solid #ddd;
  padding: 20px;
  /* height: 1000px; */
}
.title_end{
  /* display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; */
  position: absolute;
  left: 50%;
  right: 50%;
  top: 50%;
  width: 30%;
}
.top {
  width: 100%;
  position: relative;
  display: flex;
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;
}
.top_date {
  width: 100px;
  text-align: left;
  line-height: 42px;
  font-size: 18px;
}
.btn_wrap {
  flex: 1;
  text-align: right;
}
.btn_wrap ul {
  display: flex;
  flex-direction: row-reverse;
  list-style: none;
}
.felx{
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.fend {
  width: 10px;
  height: 10px;
  background: red;
  border-radius: 50%;
  /* margin-left: 20px; */
  /* text-align: center */
}
.btn_wrap ul li {
  padding: 10px 20px;
  border: 1px solid #ddd;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  list-style: none;
}
.btn_wrap ul li:hover {
  background: #ddd;
  color: red;
}
.btn_wrap ul li:first-child {
  border-left: none;
}
.btn_wrap ul li:last-child {
  border-right: none;
}
.date_wrap {
  position: relative;
}
.week {
  display: flex;
  flex-direction: row;
  padding: 20px;
  font-size: 16px;
  list-style: none;
}
.week li {
  width: 14.28%;
  text-align: center;
}
.day {
  display: flex;
  flex-direction: row;
  /* padding: 20px; */
  font-size: 16px;
  flex-wrap: wrap;
  list-style: none;
}
.day li {
  width: 14.28%;
  padding: 10px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border: 1px solid #ddd; */
  /* border-radius: 10%; */
}
.day li:nth-child(n + 8) {
  border-top: none;
}
.day li:nth-child(n + 1) {
  border-right: none;
}
.day li:nth-child(7n) {
  border-right: 1px solid #ddd;
}
.now {
  background: #f2f8fe;
  color: #1989fa;
}
</style>